import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfileEdit } from './useProfileEdit';
import ProfileForm from './ProfileForm';
import LoadingState from './LoadingState';
import { styles } from './styles';

const EditProfile = () => {
  const navigate = useNavigate();
  const {
    name,
    setName,
    bio,
    setBio,
    email,
    currentPhotoURL,
    photoFile,
    setPhotoFile,
    saving,
    loading,
    handleSave,
    handleCancel
  } = useProfileEdit();

  if (loading) {
    return <LoadingState />;
  }

  const BackIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
      <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button 
          onClick={() => navigate('/profile')} 
          style={styles.backButton}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
        >
          <BackIcon />
          <span style={styles.backText}>Back to Profile</span>
        </button>
        <h1 style={styles.headerTitle}>Edit Profile</h1>
        <p style={styles.headerSubtitle}>Update your profile information</p>
      </div>

      {/* Form Container */}
      <div style={styles.contentContainer}>
        <ProfileForm
          name={name}
          setName={setName}
          bio={bio}
          setBio={setBio}
          email={email}
          currentPhotoURL={currentPhotoURL}
          photoFile={photoFile}
          setPhotoFile={setPhotoFile}
          onSubmit={handleSave}
          saving={saving}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default EditProfile;